<div class="json-box">
  <!--<pre> {{channelBehavior | json}} </pre>-->
  <json-editor [options]="editorOptions" [data]="channelBehavior" class="full-width">
  </json-editor>
</div>
